export default class Convenio {
    private _id = Number();
    private _ativo = Boolean();
    private _dtInclusao = new Date();
    private _dtAlteracao = new Date();
    private _usuario = String();
    private _usuarioUpdate = String();
    private _descricao = String();
    private _indice = Number();
    private _idTabelaProc = Number();
    private _favorito = Boolean();
    private _idCliente = Number();

    public get id() {
        return this._id;
    }
    public set id(value) {
        this._id = value;
    }
    public get ativo() {
        return this._ativo;
    }
    public set ativo(value) {
        this._ativo = value;
    }
    public get dtInclusao() {
        return this._dtInclusao;
    }
    public set dtInclusao(value) {
        this._dtInclusao = value;
    }
    public get dtAlteracao() {
        return this._dtAlteracao;
    }
    public set dtAlteracao(value) {
        this._dtAlteracao = value;
    }
    public get usuario() {
        return this._usuario;
    }
    public set usuario(value) {
        this._usuario = value;
    }
    public get usuarioUpdate() {
        return this._usuarioUpdate;
    }
    public set usuarioUpdate(value) {
        this._usuarioUpdate = value;
    }
    public get descricao() {
        return this._descricao;
    }
    public set descricao(value) {
        this._descricao = value;
    }
    public get indice() {
        return this._indice;
    }
    public set indice(value) {
        this._indice = value;
    }
    public get idTabelaProc() {
        return this._idTabelaProc;
    }
    public set idTabelaProc(value) {
        this._idTabelaProc = value;
    }
    public get favorito() {
        return this._favorito;
    }
    public set favorito(value) {
        this._favorito = value;
    }
    public get idCliente() {
        return this._idCliente;
    }
    public set idCliente(value) {
        this._idCliente = value;
    }


    constructor(pId: number, pAtivo: boolean, pDtInclusao: Date, pdtAlteracao: Date, pUsuario: string, pUsuarioUpdate: string, pDescricao: string, pIndice: number, pIdCliente: number, pIdTabelaProc: number, pFavorito: boolean) {
        this.id = pId;
        this.ativo = pAtivo;
        this.dtInclusao = pDtInclusao;
        this.dtAlteracao = pdtAlteracao;
        this.usuario = pUsuario;
        this.usuarioUpdate = pUsuarioUpdate;
        this.descricao = pDescricao;
        this.indice = pIndice;
        this.idTabelaProc = pIdTabelaProc;
        this.favorito = pFavorito;
        this.idCliente = pIdCliente;
    }
}